<template>
  <div>
    <transition name="overlay-fade">
      <div class="overlay-message" v-show="sendOk">
        <p>
          Uw bericht is verzonden.
        </p>
      </div>
    </transition>

    <div class="dialog-content">
      <form
        name="callBackForm"
        method="post"
        action="/callBack"
        @submit.prevent="sendForm()"
      >
        <div>
          <label for="message">Welk product of onderwerp mist u?</label>
          <textarea
            id="message"
            v-model="contact.message"
            placeholder="Typ hier uw bericht"
            @input="v$.contact.message.$touch()"
            :class="{
              invalid: v$.contact.message.$invalid && v$.contact.message.$dirty
            }"
          ></textarea>
        </div>
        <div>
          <label for="email">E-mailadres</label>
          <input
            id="email"
            type="email"
            placeholder="Uw e-mailadres"
            v-model="contact.userInfo.email"
            maxlength="128"
            @input="v$.contact.userInfo.email.$touch()"
            :class="{
              invalid:
                v$.contact.userInfo.email.$invalid &&
                v$.contact.userInfo.email.$dirty
            }"
          />
        </div>

        <div class="button-holder">
          <button
            class="pill-button secondary"
            type="button"
            v-show="!sending"
            @click="$emit('close')"
          >
            Annuleren
          </button>
          <button
            id="confirm-button"
            class="pill-button"
            type="submit"
            v-show="!sending"
            :disabled="v$.$invalid"
          >
            Verzenden
          </button>
          <bouncing-spinner
            class="spinner-ct"
            v-show="sending"
          ></bouncing-spinner>
        </div>

        <section class="error" v-show="sendError">
          <span class="error-text"
            >Er is een fout opgetreden bij het verzenden van uw bericht, probeer
            het later nogmaals.</span
          >
        </section>
      </form>
    </div>
  </div>
</template>
<script>
import { ref, reactive, computed } from 'vue'
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

import { sendMail } from '@/api/api'

import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'
import { useRootStore } from '@/stores/store'

export default {
  setup(props, { emit }) {
    const printStoreStore = usePrintStoreStore()
    const rootStore = useRootStore()

    const contact = reactive({
      title: 'Productverzoek PrintStore',
      subject: 'Productverzoek PrintStore',
      userInfo: {
        email: rootStore.user.username,
        name: ''
      },
      message: '',
      to: 'camiel@rijnja.nl'
    })

    const sendOk = ref(false)
    const errorMessage = ref('')
    const sending = ref(false)
    const sendError = ref(false)

    const rules = {
      contact: {
        message: { required },
        userInfo: {
          email: { email, required }
        }
      }
    }

    const v$ = useVuelidate(rules, { contact })

    function sendForm() {
      let contactCopy = { ...contact }

      if (printStoreStore.currentCollectionName) {
        contactCopy.message =
          contactCopy.message +
          '\n\n Huidige collectie: ' +
          printStoreStore.currentCollectionName
      }

      contactCopy.message += '\n\n Thema: ' + rootStore.theme.mainThemeName

      sending.value = true
      sendMail(contactCopy).then((val) => {
        //sending.value = false

        if (val === true) {
          sendOk.value = true

          setTimeout(() => {
            //sendOk.value = false
            emit('close')
          }, 1500)
        } else {
          sendError.value = true
        }
      })
    }

    return {
      contact,
      sendOk,
      errorMessage,
      sending,
      sendError,
      sendForm,
      printStoreStore,
      v$,
      rootStore
    }
  }
}
</script>
<style lang="scss" scoped>
textarea {
  height: 150px;
  border: 1px solid #bfbfbf;
  margin-bottom: 15px;
  padding: 10px;
  background: #ececec;
  border-radius: 17px;
  border: 1px solid #ececec;
  transition: border-color 0.25s;
  width: 100%;

  &.invalid {
    border-color: var(--error-color);
  }
}

#email {
  width: 100%;
  border: none;
  background: #ececec;
  border-radius: 17px;
  height: 34px;
  margin: 0;
  padding: 0 10px;
  margin-bottom: 25px;
  border: 1px solid #ececec;
  transition: border-color 0.25s;

  &.invalid {
    border-color: var(--error-color);
  }
}

label {
  float: none;
  display: block;
  padding: 0 0 7px 0;
}

.select-holder {
  margin-bottom: 20px;
}

button.secondary {
  margin-right: 5px;
}

.button-holder {
  height: 30px;
}
</style>
